import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from "../../../../../../../../../../../../components/button";
import Icon from "../../../../../../../../../../../../components/icon";
import Input from '../../../../../../../../../../../../components/input';

function ContactEditEmailRow (props) {
    const { t } = useTranslation();

    return (
        <div className={`contact-edit-email-row d-flex py-2 mb-1`}>
            <div className="col-1 d-flex align-items-center justify-content-center">
                {
                    props.index
                        ?
                        props.index === 0
                            ?
                            <svg width="20" height="20" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <path
                                    d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"/>
                            </svg>
                            :
                            ''
                        :
                        <svg width="20" height="20" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path
                                d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"/>
                        </svg>
                }
            </div>
            <div className="col-5">
                <Input
                    type="email"
                    name="email"
                    id={props.index ? `email-${props.index}` : 'email'}
                    defaultValue={props.emailAddress.email}
                    placeholder={t("fieldEmail")}
                    autoComplete={'' + Math.random()}
                    disabled={props.disabled}
                />
            </div>
            <div className="col-5">
                <Input
	                id={`email-label-${props.index}`}
	                list={`email-label-list-${props.index}`}
                    name="email-label"
	                defaultValue={props.emailAddress.label}
					placeholder={t("fieldLabelPlaceholder")}
	                disabled={props.disabled}
                />
	            <datalist id={`email-label-list-${props.index}`}>
                    <option value={t("fieldLabelWork")}/>
                    <option value={t("fieldLabelHome")}/>
                    <option value={t("fieldLabelOther")}/>
	            </datalist>
            </div>
            <div className="col-1 d-flex align-items-center justify-content-center">
                {
                    props.index === 0
                        ?
                        <Button className="btn-link p-0 add" onClick={props.newEmailRow}>
                            <Icon name="plus-circle"/>
                        </Button>
                        :
                        null
                }
                {
                    props.index > 0
                        ?
                        <Button data-index={props.index} className="btn-link p-0 delete" onClick={props.deleteEmailRow}>
                            <Icon name="times"/>
                        </Button>
                        :
                        null
                }
            </div>
        </div>
    );
}

export default ContactEditEmailRow;
